// eslint-disable-next-line camelcase
export type { ActivateDebitCard_activateDebitCard as ActivateDebitCardResponse } from './gql-types/ActivateDebitCard'

export enum CardSize {
  SMALL = 'SMALL',
  LARGE = 'LARGE',
}
